import { cn } from "@/lib/cn";

/**
 * Inline keyboard hint chip — `<Kbd>j</Kbd>` / `<Kbd>⌘K</Kbd>`.
 *
 * Used in tooltips, menu hints, and the command center so keyboard
 * shortcut affordances render the same way everywhere instead of each
 * surface re-styling a <span class="rounded px-1 …">.
 */
export function Kbd({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        "inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded border border-line-subtle bg-bg-base text-fg-dim text-[10.5px] font-mono leading-none",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
